<div class="modal-header">
    <h4 class="modal-title">Image - {{currentImage().label}}</h4>
    <button type="button" class="btn-close" data-dismiss="modal" tabindex="-1" (click)="reset()"></button>
</div>
<div class="modal-body">
    @for (item of injectContent; track item.content) {
        @if (item.injectType === INJECT_TYPE.COMPONENT) {
            <ng-container *ngComponentOutlet="item.content; inputs: item.data"/>
        } @else {
            <ng-container [ngTemplateOutlet]="$any(item.content)" [ngTemplateOutletContext]="{ $implicit: item.data }" />
        }
    }
    <div style="min-height: 60vh; position: relative">
        <div class="position-absolute top-0 bottom-0 start-0 end-0 h-100 w-100">
            <ngx-panzoom [zoomLevels]="8" [freeMouseWheelFactor]="0.005">
                <div class="position-relative">
                    <img [src]="imageLink" id="enlarged-image">
                </div>
            </ngx-panzoom>
        </div>
    </div>
</div>
<div class="modal-footer">
    <p class="text-danger fw-bold me-auto">Scroll/Pinch to zoom</p>
@if (imgArr()?.length > 1) {
    <button class="btn btn-dark" (click)="index.set(index() - 1)" [disabled]="index() === 0"><i class="fas fa-caret-left"></i></button>
    <button class="btn btn-dark" (click)="index.set(index() + 1)" [disabled]="index() === imgArr().length-1"><i class="fas fa-caret-right"></i></button>
}
    <button class="btn btn-outline-dark" (click)="rotate()"><i class="fas fa-undo"></i> Rotate</button>
@if (canDelete) {
    <button class="btn btn-danger" (click)="deleteImage(currentImage().url)"><i class="fas fa-trash-alt"></i> Delete</button>
}
</div>